import { Box, Typography } from '@mui/material';
import { SingleFieldDynamicFields } from '../singleFieldDynamicFields';
import { FormikProps } from 'formik';
import { SingleDynamicField } from '../../../../../shared/types/assistant';

export const SmartResponseFormat = ({
    formikSmartResponseFormat,
}: {
    formikSmartResponseFormat: FormikProps<{
        [key: string]: SingleDynamicField[];
    }>;
}) => {
    return (
        <SingleFieldDynamicFields
            formik={formikSmartResponseFormat}
            name="smartResponseFormat"
            label="Formato de Respuesta Inteligente (Ejemplos Avanzados)"
            description="Añade ejemplos de interacción entre un usuario y el asistente virtual para ilustrar cómo responde en diferentes escenarios. Muestra casos específicos en los que el asistente proporciona respuestas rápidas y precisas, usa analogías para facilitar la comprensión o escala la consulta cuando es necesario."
            example={
                <Box display="flex" flexDirection="column" padding={2}>
                    <Typography color="text.secondary">
                        📍 Escalamiento de Caso
                    </Typography>
                    <Typography color="text.secondary">
                        <strong>💬 Usuario:</strong> No encuentro mi certificado
                        de crédito.
                    </Typography>
                    <Typography color="text.secondary">
                        <strong>🤖 Nova:</strong> Voy a escalar tu consulta para
                        que un especialista lo revise. Te notificaremos en
                        breve. Gracias por tu paciencia.
                    </Typography>
                </Box>
            }
        />
    );
};
